/* istanbul ignore file */

import { createPdfDocument } from '../../document-creation'
import { createCommonPdf } from '../common/pdf-document'
import template from './template'
import { commonSection } from 'core/service/pdf-generation/products/common/sections'
import { section } from 'core/service/pdf-generation/products/saving/sections'

export const basicPlanLabel = (basicPlan) => basicPlan.fullNameThai || basicPlan.nameThai

export const createMiniBIDocDefinition = async (props) => {
  const pdfTemplate = await template(props)
  return {
    content: [
      ...commonSection.profile({ ...props, basicPlanLabel }),
      ...commonSection.productBenefits({ ...props }),
      ...commonSection.riders(props),
      ...section.policyValueTable(props),
      commonSection.legalDisclaimerMarketConduct(props),
    ],
    ...pdfTemplate,
  }
}

export const createFullBIDocDefinition = async (props) => {
  const _props = { ...props, biType: props.biType }
  const pdfTemplate = await template(_props)
  const paymentChannels = await commonSection.paymentChannels(props)

  return {
    content: [
      ...commonSection.profile({ ...props, basicPlanLabel }),
      ...commonSection.productBenefits({ ...props }),
      ...commonSection.riders(props),
      commonSection.basicPlanCondition(),
      ...section.policyValueTable(props),
      commonSection.legalDisclaimerMarketConduct(props),
      paymentChannels,
      commonSection.signature(props),
    ],
    ...pdfTemplate,
  }
}

const createFullBIPdf = createPdfDocument(createFullBIDocDefinition)
const createMiniBIPdf = createPdfDocument(createMiniBIDocDefinition)

export const createSavingPdf = async (props) => {
  return await createCommonPdf(props, createFullBIPdf, createMiniBIPdf)
}
